import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "style" }
const _hoisted_2 = { class: "optionsBox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "主题色", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "设置一个喜欢的主题色", -1)
const _hoisted_5 = { class: "operation" }
const _hoisted_6 = { class: "colors" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "btns" }, null, -1)
const _hoisted_9 = { class: "optionsBox" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "背景图", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "随机 Bing 每日壁纸或自定义喜爱的壁纸", -1)
const _hoisted_12 = { class: "operation" }
const _hoisted_13 = { class: "btns" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("下一张")
const _hoisted_17 = { class: "optionsBox" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "设置按钮", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "指定设置按钮的位置", -1)
const _hoisted_20 = { class: "operation" }
const _hoisted_21 = { class: "optionsBox" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "毛玻璃", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "是否开启毛玻璃效果", -1)
const _hoisted_24 = { class: "operation" }

import data from "@/data/data";
import notify from "@/utils/notify/notify";
import local from "@/utils/localData/local";
import { ref } from "vue";
import themeColor from "@/utils/themeColor";

/**
 * 保存配置并提示
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'style',
  setup(__props) {

function saveAndNotify(msg: Array<string>, type: boolean) {
    notify(type ? msg[0] : msg[1], type ? 1 : 3);
    local.save();
}

/**
 * 背景图 url
 */
const bgUrl = ref(data.saveData.bgSet ? data.saveData.bgLink : "");

/**
 * 保存背景图
 */
function saveBgUrl() {
    data.saveData.bgLink = bgUrl.value;
    local.save();
    notify("背景图设置成功", 1);
}

/**
 * 重置背景图
 */
function refreshBg() {
    bgUrl.value = "";
    data.saveData.bgLink = "";
    data.saveData.bgSet = false;
    local.save();
    notify("背景图重置成功", 1);
}

/**
 * 下一张 bing 壁纸
 */
function nextBingBg() {
    data.bingIndex++;
    if (data.bingIndex == data.bingData.length) {
        data.bingIndex = 0;
    }
    data.saveData.bgLinkContent = data.bingData[data.bingIndex].copyright;
    data.saveData.bgLinkHref = data.bingData[data.bingIndex].copyrightlink;
    data.saveData.bgLink =
        "https://cn.bing.com/" + data.bingData[data.bingIndex].url;
    bgUrl.value = data.saveData.bgLink;
    data.saveData.bgSet = true;
    local.save();
}

return (_ctx: any,_cache: any) => {
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).defaultColors, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (_unref(themeColor).change(item)),
              style: _normalizeStyle('background: ' + item + ';')
            }, null, 12, _hoisted_7))
          }), 128))
        ]),
        _createVNode(_component_el_color_picker, {
          modelValue: _unref(data).saveData.themeColor,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).saveData.themeColor) = $event)),
          "color-format": "rgb",
          onChange: _unref(themeColor).change
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_input, {
          modelValue: bgUrl.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bgUrl).value = $event)),
          placeholder: "请输入图片链接"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: saveBgUrl
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: refreshBg
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: nextBingBg
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_select, {
          modelValue: _unref(data).saveData.settingLocation,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).saveData.settingLocation) = $event)),
          size: "small",
          onChange: _unref(local).save
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).settingSelect, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_el_switch, {
          modelValue: _unref(data).saveData.AeroState,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(data).saveData.AeroState) = $event)),
          "active-color": "#13ce66",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (
                        saveAndNotify(
                            ['毛玻璃效果已开启', '毛玻璃效果已关闭'],
                            _unref(data).saveData.AeroState
                        )
                    ))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})